<template>
  <q-table
    flat
    bordered
    :data="billingsByAffiliate"
    :columns="columns"
    row-key="id"
    :pagination.sync="pagination"
    selection="multiple"
    :selected.sync="itemSelected"
    :no-data-label="$t('no_data')"
  >
    <template v-slot:bottom>
      <!-- <pagination-table
              @change="getStatementsAdmin"
              :data="reqPagination"
              :pagination="pagination"
            /> -->
      <q-toolbar class="bg-transparent" :class="!$q.dark.isActive ? 'text-dark' : 'text-white'">
        <div class="row items-center">
          <span class="q-mr-md">{{$t('rows_per_page')}}</span>
            <q-select
            v-model="pagination.rowsPerPage"
            :options="[10, 20, 50, 100]"
            dense
            @input="onRowsPerPageChange"
            style="max-width: 60px; padding-left: 8px; padding-right: 8px"
            />
           <span>Total: {{ reqPagination.total }}</span>
        </div>
        <q-space />
        <q-pagination
          unelevated
          v-model="currentPage"
          color="primary"
          :max="reqPagination.last_page"
          :max-pages="6"
          boundary-numbers
          direction-links
        />
      </q-toolbar>
    </template>
    <template v-slot:top>
      <div class="q-gutter-x-md">
        <q-btn
          color="positive"
          :label="$t('release')"
          no-caps
          unelevated
          class="q-px-md"
          :disabled="itemSelected.length == 0"
          @click="onAction('liberate')"
        >
        </q-btn>
        <q-btn
          color="primary"
          :label="$t('cancel_release')"
          no-caps
          unelevated
          class="q-px-md"
          :disabled="itemSelected.length == 0"
          @click="onAction('cancel')"
        >
        </q-btn>
      </div>
    </template>
  </q-table>
</template>

<script>
import FinancialMixin from '../../mixins/FinancialMixin';

export default {
  name: 'ListApproveInvoices',
  mixins: [FinancialMixin],

  data() {
    return {
      itemSelected: [],
      params: {
        payout: null,
        paymentDay: null
      },
      columns: [
        {
          name: 'affilate_id',
          required: true,
          label: this.$t('affiliate_id'),
          align: 'left',
          field: 'affiliate_id',
          sortable: true
        },
        {
          name: 'affiliate_idv2',
          required: true,
          label: 'ID v2',
          align: 'left',
          field: 'affiliate_idv2',
          sortable: true
        },
        {
          name: 'affilate',
          required: true,
          label: this.$t('affiliate'),
          align: 'left',
          field: 'affiliate_name',
          sortable: true
        },
        {
          name: 'campaign_id',
          required: true,
          label: this.$t('campaign_id'),
          align: 'left',
          field: 'campaign_id',
          sortable: true
        },
        {
          name: 'date',
          required: true,
          label: this.$t('month_year_reference'),
          align: 'left',
          field: 'date',
          sortable: true
        },
        {
          name: 'campaign_name',
          required: true,
          label: this.$t('campaign'),
          align: 'left',
          field: 'campaign_name',
          sortable: true
        },
        {
          name: 'value',
          required: true,
          label: this.$t('invoice_amount'),
          align: 'left',
          field: 'value',
          sortable: true
        },
        {
          name: 'state_id',
          required: true,
          label: 'Status',
          field: 'state_id',
          format: (state_id) => this.formatStates(state_id),
          align: 'center'
        }
      ],
      pagination: {
        sortBy: 'trademark',
        descending: true,
        rowsPerPage: 10
      }
    };
  },

  watch: {
    currentPage() {
      if (this.reqPagination.from != this.reqPagination.current_page) {
        this.getBillingsByAffiliate(
          this.filterBillingsByAffiliate.dateFrom,
          this.filterBillingsByAffiliate.dateTo,
          this.filterBillingsByAffiliate.campaignId,
          this.filterBillingsByAffiliate.affiliateId,
          this.filterBillingsByAffiliate.state_id,
          this.currentPage,
          this.pagination.rowsPerPage
        );
      }
    }
  },

  computed: {
    currentPage: {
      get() {
        return this.reqPagination.current_page;
      },
      set(value) {
        this.ActionSetPagination({
          ...this.reqPagination,
          current_page: value
        });
      }
    }
  },

  created() {
    const savedRowsPerPage = localStorage.getItem('rowsPerPage');

    if (savedRowsPerPage) {
        this.pagination.rowsPerPage = parseInt(savedRowsPerPage, 10);
    }
    },

  methods: {
    onAction(action) {
      const itemsData = this.itemSelected
        .filter((item) => (action == 'liberate' ? item.state_id === 1 : item.state_id === 2))
        .map((item) => ({
          dataInicio: this.filterBillingsByAffiliate.dateFrom,
          dataFim: this.filterBillingsByAffiliate.dateTo,
          affiliateId: item.affiliate_id,
          state_id: item.state_id,
          campaignId: item.campaign_id,
          liberate: action === 'liberate' ? true : false
        }));

      if (itemsData.length == 0) {
        this.errorNotify(
          action == 'liberate'
            ? this.$t('selected_commission_already_released')
            : this.$t('selected_commission_already_pending')
        );
        // this.itemSelected = [];
        return;
      }

      this.$q
        .dialog({
          title: action == 'liberate' ? this.$t('liberate_commission') : this.$t('cancel_release_commission'),
          message:
            action == 'liberate'
              ? this.$t('confirm_liberate_selected_affiliates')
              : this.$t('confirm_cancel_release_selected_affiliates'),
          persistent: true,
          ok: action == 'liberate' ? { color: 'positive' } : { color: 'primary' },
          cancel: this.$t('cancel')
        })
        .onOk(() => {
          this.onActionCommission(action, itemsData);
        });
    },

    async onActionCommission(action, itemsData) {
      this.onLoading(true);

      try {
        const { status } = await this.$http.post(`/v2/redirect`, {
          app: 'finance',
          path: `/api/statements_admin/liberate`,
          params: {
            data: itemsData
          }
        });
        if (status === 200) {
          this.getBillingsByAffiliate(
            this.filterBillingsByAffiliate.dateFrom,
            this.filterBillingsByAffiliate.dateTo,
            this.filterBillingsByAffiliate.campaignId,
            this.filterBillingsByAffiliate.affiliateId,
            this.filterBillingsByAffiliate.state_id,
            this.currentPage,
            this.pagination.rowsPerPage
          );
          this.itemSelected = [];
          this.successNotify(
            action == 'liberate' ? this.$t('commissions_liberated_success') : this.$t('releases_cancelled_success')
          );
        }
      } catch (error) {
        if (error.response && error.response.status === 500)
          this.errorNotify(this.$t('problem_try_again_later'));
        else this.errorNotify(error);
      } finally {
        this.onLoading(false);
      }
    },

    formatPaymentDate(date) {
      if (date == null) return this.$t('not_defined_date');
      return (val) => this.$moment(val).format('L');
    },

    formatStates(state) {
      switch (state) {
        case 1:
          return this.$t('pending_release');

        case 2:
          return this.$t('liberated');

        case 3:
          return this.$t('requested');

        case 4:
          return this.$t('approved');

        case 5:
          return this.$t('paid');

        case 11:
          return this.$t('refused');

        case 12:
          // return 'Pré-Aprovado';
          return this.$t('requested');

        default:
          return '-';
      }
    },
    onRowsPerPageChange(value) {
        this.pagination.rowsPerPage = value;

        localStorage.setItem('rowsPerPage', value);

        this.getBillingsByAffiliate(
        this.filterBillingsByAffiliate.dateFrom,
        this.filterBillingsByAffiliate.dateTo,
        this.filterBillingsByAffiliate.campaignId,
        this.filterBillingsByAffiliate.affiliateId,
        this.filterBillingsByAffiliate.state_id,
        1,
        value
        );
    },
    }
};
</script>
